import { Component, Emit, Prop, Watch } from 'vue-property-decorator';
import { AbstractWidgetConfig } from "@/components/Dashboard/Widgets/AbstractWidget/AbstractWidget";
import { WidgetConfigBulkShipmentProgressStatus, WidgetData } from "@/components/Dashboard/Widgets/types/Widget";

type AmountUnit = {
    label: string
    value: number
}

@Component({
    components: {
    }
})
export default class WidgetConfigBulkShipmentProgressStatusPart extends AbstractWidgetConfig<WidgetConfigBulkShipmentProgressStatus> {
    config: WidgetConfigBulkShipmentProgressStatus = {
        unit: {
            label: '円',
            value: 1
        }
    }
    @Prop()
    private value!: boolean
    @Prop()
    public widgetData!: WidgetData;
    private units: AmountUnit[] = [
        {
            label: '円',
            value: 1
        },
        {
            label: '千円',
            value: 1000
        }
    ]

    @Emit('input')
    input(value: boolean): void {
        value
    }

    @Emit('updateConfig')
    updateConfig() {
        return this.config
    }

    created(): void {
        this.initConfig()
        this.validate()
    }

    private initConfig() {
        if (!this.widgetData.config) {
            this.config = {
                unit: {
                    label: '円',
                    value: 1
                }
            }
        } else {
            this.config = {...this.widgetData.config}
        }
    }

    @Watch('widgetData')
    whenOpen(): void {
        this.initConfig()
        this.validate()
    }

    validate(): void {
        let valid = true
        if (!this.config.unit.value) {
            valid = false
        }
        this.input(valid)
        this.updateConfig()
    }
}